import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'
import axios from 'axios'


export const useOrganizationStore = defineStore('organization', {
  id: 'organization',
  state: () => ({
    items: [],
    api: '/api/v1/organizations'
  }),
  getters: {
    ...getters
  },
  actions: {
    ...actions,
    async markAsVerified(organizationId) {
      const { data } = await axios.post(`/api/v1/organizations/${organizationId}/mark-as-verified`)
      this.itemPatchState(data)
      return data
    },
    async markAsNotVerified(organizationId) {
      const { data } = await axios.post(`/api/v1/organizations/${organizationId}/mark-as-not-verified`)
      this.itemPatchState(data)
      return data
    },
    async autologinAsOrganization(organizationId) {
      const { data } = await axios.post(`/api/v1/organizations/${organizationId}/autologin-token`)
      return data.token
    },
    async fetchDashboardReport(organizationId) {
      const { data } = await axios.get(`/api/v1/organizations/${organizationId}/dashboard-report`)
      return data
    }
  }
})
